import { useState } from "react";
import { FiZap, FiChevronDown, FiChevronUp } from "react-icons/fi";
import { AIInputSection } from "../../../avaliations/AIInputSection";

interface AISectionProps {
  aiInputValue: string;
  onInputChange: (value: string) => void;
  onAnalyze: (text?: string) => void;
  onAudioAnalyze: (audioBlob: Blob) => void;
  onImageAnalyze: (imageFile: File) => void;
  placeholder: string;
  disabled: boolean;
  loading: boolean;
}

export const AISection = ({
  aiInputValue,
  onInputChange,
  onAnalyze,
  onAudioAnalyze,
  onImageAnalyze,
  placeholder,
  disabled,
  loading,
}: AISectionProps) => {
  const [isMinimized, setIsMinimized] = useState(false);

  return (
    <div className="rounded-lg sm:rounded-xl md:rounded-2xl border border-stroke bg-gradient-to-br from-purple-50 to-purple-50/50 p-3 sm:p-4 md:p-6 shadow-sm dark:border-strokedark dark:from-purple-950/20 dark:to-purple-950/10">
      <button
        type="button"
        onClick={() => setIsMinimized(!isMinimized)}
        className="w-full mb-3 sm:mb-3.5 md:mb-4 flex items-center gap-2 sm:gap-2.5 md:gap-3 text-left transition-all active:opacity-80 touch-manipulation"
      >
        <div className="rounded-md sm:rounded-lg md:rounded-xl bg-gradient-to-br from-purple-600 to-purple-600 p-1.5 sm:p-2 md:p-2.5 text-white shadow-sm flex-shrink-0">
          <FiZap size={16} className="sm:w-[18px] sm:h-[18px] md:w-5 md:h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <h4 className="text-sm sm:text-base md:text-lg font-bold text-gray-900 dark:text-white">
            Criar Treino com IA
          </h4>
          <p className="text-[11px] sm:text-xs text-gray-600 dark:text-gray-400 line-clamp-2">
            Descreva o treino e a IA criará um plano completo usando exercícios
            da base
          </p>
        </div>
        <div className="flex-shrink-0 text-gray-400 dark:text-gray-500">
          {isMinimized ? (
            <FiChevronDown size={20} className="sm:w-5 sm:h-5" />
          ) : (
            <FiChevronUp size={20} className="sm:w-5 sm:h-5" />
          )}
        </div>
      </button>
      {!isMinimized && (
        <div className="animate-in fade-in slide-in-from-top-2 duration-200">
          <AIInputSection
            value={aiInputValue}
            onChange={onInputChange}
            onAnalyze={onAnalyze}
            onAudioAnalyze={onAudioAnalyze}
            onImageAnalyze={onImageAnalyze}
            placeholder={placeholder}
            disabled={disabled}
            loading={loading}
            removeDescription={true}
          />
        </div>
      )}
    </div>
  );
};
